<ng-container [ngSwitch]="notifyType">
  <ng-container *ngSwitchCase="'slack'"
    >{{ message }} and share the results in
    <ng-template #slackChannelNotChosenYet>Slack </ng-template>

    <ng-container *ngIf="slackChannel; else slackChannelNotChosenYet">
      <span *ngIf="slackChannel.type === 'public'"
        >the <span class="bold" data-test="channel-name">#{{ slackChannel.name }}</span> Slack channel
      </span>
      <span *ngIf="slackChannel.type === 'private'" class="inline-flex" data-test="channel-name"
        >the <capra-icon icon="icon-lock"></capra-icon>
        <span class="private-slack-channel">private Slack channel </span>
      </span>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'email'"
    >{{ message }} and email the results

    <span *ngIf="numberOfSubscribers"
      >to
      <span class="bold"
        >{{ numberOfSubscribers }}
        <ng-container [ngPlural]="numberOfSubscribers">
          <ng-template ngPluralCase="=1">subscriber </ng-template>
          <ng-template ngPluralCase="other">subscribers </ng-template>
        </ng-container>
      </span>
    </span>
  </ng-container>

  <ng-container *ngSwitchDefault
    >{{ message }}
  </ng-container>
</ng-container>
